import { DrawAPI } from '../../../api/spidermap/DrawAPI';

export class DrawCommand {
    generate(form, successCallback, errorCallback) {
        const apiResult = DrawAPI.generate({referenceDate: form.date, stops: form.stops, qrCodeUrl: form.qrCode});
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback("Spider Maps gerados com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a gerar os Spider Maps");
            }
        });
    }

    list(successCallback, errorCallback) {
        const apiResult = DrawAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os dados");
            }
        });
    }

    delete(fileName, successCallback, errorCallback) {
        const apiResult = DrawAPI.delete(fileName);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos eliminados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a eliminar os documentos.");
            }
        });
    }
}
